import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { formatApiError } from "@/lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const { settings } = useSettings();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F4F2EE] px-4">
      <div className="w-full max-w-md rounded-3xl border border-brand-line bg-white p-8 shadow-sm">
        <div className="text-center">
          {settings.logo && <img src={settings.logo} alt="logo" className="mx-auto h-16 w-16 rounded-full object-contain" />}
          <h1 className="mt-4 font-heading text-3xl text-brand-dark">Admin Login</h1>
          <p className="mt-1 text-sm text-brand-muted">{settings.business_name || "Taanya Homefoods"} Dashboard</p>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="mb-1.5 block text-sm font-medium text-brand-muted">Email</label>
            <input
              data-testid="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-xl border border-brand-line px-4 py-3 outline-none focus:ring-2 focus:ring-brand-gold"
            />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-brand-muted">Password</label>
            <input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-xl border border-brand-line px-4 py-3 outline-none focus:ring-2 focus:ring-brand-gold"
            />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-600">{error}</p>}
          <button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="flex w-full items-center justify-center gap-2 rounded-full bg-brand px-6 py-3 font-medium text-white hover:bg-brand-hover disabled:opacity-60"
          >
            <Lock className="h-4 w-4" /> {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
